import React from 'react';
import styled from 'styled-components';
import { disableInput } from '../../../../../../../mixins/custom';
const StyledContainer = styled.div.withConfig({
  componentId: "index__sc-17h5ejf-0"
})(["", ""], ({
  isDisabled
}) => isDisabled && disableInput);
export const DisableContainer = ({
  isDisabled,
  children
}) => {
  return React.createElement(StyledContainer, {
    isDisabled: isDisabled
  }, children);
};